// core
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { array, bool, func, object, string } from "prop-types";
import { connect } from "react-redux";
import { Navbar, Nav, NavItem } from "react-bootstrap";

// components
import CampaignChooser from "./CampaignChooser";
import AccountChooser from "./AccountChooser";

// assets
import logoOvermedia from "../_assets/images/logo.png";
import Restricted from "./Restricted";

const Panel = ({ campaign, campaigns, logout, submenu = false, clientId, userProfile }) => {
  document.body.style.backgroundColor = "#fff";
  return (
    <div>
      <nav className="navbar navbar-default navbar--no-margin navbar--no-shadow">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#panel-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <Link className="navbar-brand navbar-brand--overmedia" to="/campaigns">
              <img src={logoOvermedia} alt="Overmedia Logo" />
            </Link>
          </div>
          <div className="collapse navbar-collapse" id="panel-menu">
            <AccountChooser />
            {campaigns && campaigns.length > 0 && <CampaignChooser campaigns={campaigns} campaign={campaign} />}
            <p className="navbar-text navbar-right">
              <a className="navbar-link" onClick={logout}>
                Sair
              </a>
            </p>
            <Restricted accepted={["overmedia", "admin"]}>
              <p className="navbar-text navbar-right">
                <Link className="navbar-link" to="/campaigns/users">
                  Usuários
                </Link>
              </p>
              <p className="navbar-text navbar-right">
                <Link className="navbar-link" to="/campaigns/devices">
                  <i>Devices</i>
                </Link>
              </p>
            </Restricted>
            {clientId === "5989f2f901a57c0004000001" && (
              <p className="navbar-text navbar-right">
                <Link className="navbar-link" to="/campaigns/backlog/itau">
                  Backlog
                </Link>
              </p>
            )}
          </div>
        </div>
      </nav>
      {submenu && (
        <Navbar inverse>
          <Nav>
            <LinkContainer exact to={`/campaigns/${campaign.id}/videos`}>
              <NavItem>Videos</NavItem>
            </LinkContainer>
            <LinkContainer exact to={`/campaigns/${campaign.id}/stats`}>
              <NavItem>Estatísticas</NavItem>
            </LinkContainer>
          </Nav>
        </Navbar>
      )}
    </div>
  );
};

Panel.propTypes = {
  campaign: object,
  campaigns: array,
  logout: func,
  submenu: bool,
  clientId: string
};

const mapStateToProps = state => ({
  clientId: state.app.user.client_id,
  userProfile: state.app.user.profile
});

export default withRouter(connect(mapStateToProps)(Panel));



// WEBPACK FOOTER //
// ./src/components/Panel.js